import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'
import { HttpErrorResponse } from '@angular/common/http'

import * as ProjectorContainersActions from './projector-containers.actions'
import { ProjectorContainer } from './projector-containers.models'

export const PROJECTOR_CONTAINERS_FEATURE_KEY = 'projectorContainers'

export interface ProjectorContainerState extends EntityState<ProjectorContainer> {
  selectedId?: string
  loaded: boolean
  editCreateLoaded: boolean
  isLoading: boolean
  isReady: boolean
}

export interface ProjectorContainerPartialState {
  readonly [PROJECTOR_CONTAINERS_FEATURE_KEY]: ProjectorContainerState
}

export const projectorContainerAdapter: EntityAdapter<ProjectorContainer> = createEntityAdapter<ProjectorContainer>({
  selectId: (model: ProjectorContainer) => model.uuid,
})

export const initialProjectorContainerState: ProjectorContainerState = projectorContainerAdapter.getInitialState({
  loaded: false,
  editCreateLoaded: true,
  isLoading: false,
  isReady: false,
})

const reducer = createReducer(
  initialProjectorContainerState,

  on(ProjectorContainersActions.loadProjectorContainers, (state) => ({
    ...state,
    loaded: false,
  })),
  on(ProjectorContainersActions.loadProjectorContainersSuccess, (state, { projectorContainers }) =>
    projectorContainerAdapter.setAll(projectorContainers, { ...state, loaded: true }),
  ),
  on(ProjectorContainersActions.loadProjectorContainersFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(ProjectorContainersActions.selectProjectorContainer, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(ProjectorContainersActions.clearSelectedProjectorContainer, (state) => ({
    ...state,
    selectedId: undefined,
  })),

  on(ProjectorContainersActions.updateSelectedProjectorContainerSuccess, (state, { update }) =>
    projectorContainerAdapter.updateOne(update, state),
  ),
  on(ProjectorContainersActions.createProjectorContainerSuccess, (state, { projectorContainer }) =>
    projectorContainerAdapter.addOne(projectorContainer, state),
  ),
  on(
    ProjectorContainersActions.createProjectorContainerSuccess,
    ProjectorContainersActions.createProjectorContainerFailure,
    ProjectorContainersActions.updateSelectedProjectorContainerSuccess,
    ProjectorContainersActions.updateSelectedProjectorContainerFailure,
    (state) => ({
      ...state,
      editCreateLoaded: true,
    }),
  ),
  on(
    ProjectorContainersActions.createProjectorContainer,
    ProjectorContainersActions.updateSelectedProjectorContainer,
    (state) => ({
      ...state,
      editCreateLoaded: false,
    }),
  ),
  on(ProjectorContainersActions.deleteProjectorContainerSuccess, (state, { uuid }) =>
    projectorContainerAdapter.removeOne(uuid, state),
  ),
  on(ProjectorContainersActions.deleteProjectorContainerFailure, (state, { error }) => ({
    ...state,
  })),

  // Projector Container Data Initialization Actions
  on(ProjectorContainersActions.loadProjectorContainerData, (state) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(ProjectorContainersActions.projectorContainerDataLoadedAndReady, (state) => ({
    ...state,
    isLoading: false,
    isReady: true,
  })),
  on(ProjectorContainersActions.projectorContainerDataLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    isReady: false,
  })),
)

export function projectorContainersReducer(state: ProjectorContainerState | undefined, action: Action) {
  return reducer(state, action)
}
